<template>
  <div>
    <PageLoader v-bind:storage="appLoading" />
    <v-dialog v-model="dialog" width="800px">
      <v-card width="800px">
        <v-img contain :src="mediaURL + dialogImg"> </v-img>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="showSnackBar" color="#FF1313" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout wrap justify-center>
      <v-flex xs12 sm9 md9 lg12 text-left pt-4 pl-5 >
        <v-btn
          width="180px"
          small
          tile
          depressed
          :ripple="false"
          class="text-capitalize"
          color="#EFEFEF"
          @click="$refs.file7.click()"
          style="font-size: 14px; font-family: poppinssemibold"
        >
          upload image
          <v-icon>mdi-upload</v-icon>
        </v-btn>
        <input
          v-show="false"
          accept="image/*"
          id="file7"
          ref="file7"
          multiple="multiple"
          type="file"
          @change="uploadImages"
        />
      </v-flex>
      <v-flex xs12>
        <v-layout wrap px-4>
          <v-flex py-4 xs2 px-1 v-for="(item, i) in views" :key="i">
            <v-card outlined>
              <v-layout wrap>
                <v-flex xs12>
                  <v-img height="200px" :src="item" contain> </v-img>
                </v-flex>
                <v-flex xs12>
                  <v-btn block color="error" @click="splice(i)"> Delete </v-btn>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
          <v-flex py-4 xs2 px-1 v-for="(item, i) in existimg" :key="i">
            <v-card outlined>
              <v-layout wrap>
                <v-flex xs12 class="mx-auto">
                  <v-img
                    @click="opendialog(item)"
                    height="200px"
                    :src="mediaURL + item"
                    contain
                  >
                  </v-img>
                </v-flex>
                <v-flex x12>
                  <v-btn block color="error" @click="removePhoto(item, i)">
                    Delete
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs6 py-4>
        <v-btn block dark color="red" @click="uploadAllImages"> Save</v-btn>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
export default {
  props: ["storage"],
  data() {
    return {
      file7: null,
      url7: null,
      images: [],
      views: [],
      formData: new FormData(),
      existimg: [],
      showSnackBar: false,
      msg: true,
      timeout: 2000,
      appLoading: false,
      dialog: false,
      dialogImg: null,
    };
  },

  mounted() {
    this.existimg = this.storage.shopImages;
  },
  methods: {
    opendialog(item) {
      this.dialogImg = item;
      this.dialog = true;
    },

    uploadImages() {
      this.file7 = this.$refs.file7.files;
      for (let i = 0; i < this.file7.length; i++) {
        this.images.push(this.file7[i]);
        this.views.push(URL.createObjectURL(this.file7[i]));
        console.log(this.images);
      }

      // this.url7 = URL.createObjectURL(this.file7);
    },
    removeImageArray(i) {
      var values = this.formData.getAll("photos");
      values.splice(i, 1);
      this.formData.set("photos", values);
      this.imageArray.splice(i, 1);
    },
    splice(item) {
      this.views.splice(item, 1);
      this.images.splice(item, 1);
      console.log("deleted");
    },

    uploadAllImages() {
      console.log("this.images", this.images);
      for (var i = 0; i < this.images.length; i++)
        this.formData.append("shopImages", this.images[i]);

      axios({
        method: "post",
        url: "seller/profile/level1",
        data: this.formData,
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;

          if (response.data.status == true) {
            this.formData = new FormData();
            this.images = [];
            // this.views =[]
            this.msg = response.data.msg;
            this.msg = "Images Uploaded Successfully";
            this.showSnackBar = true;
            // this.getProfile()
          } else {
            this.msg = "Can't Upload Images";
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    removePhoto(i) {
      //  this.existimg.splice(i,1)
      //  console.log(i,'i')

      var key = [];
      // console.log(item)
      // this.product.photos.splice(value, 1);
      key.push(i);
      this.appLoading = true;
      axios({
        method: "POST",
        url: "shop/images/delete/" + this.storage._id,
        data: { key: key },
        // data:{key:i},
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.appLoading = false;
          if (response.data.status == true) {
            this.showSnackBar = true;
            this.msg = "Deleted Successfully";
            this.getProfile();
          } else {
            this.msg = "Can't Delete Image";
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    //new lines
    getProfile() {
      axios({
        method: "post",
        url: "user/me",
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.data.status) {
            this.existimg = response.data.data.sellerid.shopImages;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>